module.exports = __webpack_public_path__ + "static/media/disabledHorizontalTicketIcon.bca10321.svg";